import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const links = [
  { to: '/curriculum', key: 'butlerJob.path.linkCurriculum' },
  { to: '/skills', key: 'butlerJob.path.linkSkills' },
  { to: '/seminar', key: 'butlerJob.path.linkSeminar' },
];

function renderParagraphs(text: string, className: string) {
  return (
    <>
      {text
        .split(/\n{2,}/)
        .map((part) => part.trim())
        .filter((part) => part.length > 0)
        .map((part, index) => (
          <p key={index} className={className}>
            {part}
          </p>
        ))}
    </>
  );
}

export default function PathToCareer() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-8 md:px-12">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('butlerJob.path.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.path.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('butlerJob.path.titleEn')}
          </p>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-10 items-start">
          <div className="relative w-full aspect-[4/3] overflow-hidden border border-background-200/60">
            <img
              src="/images/generated/facilities-campus-2026.jpg"
              alt={t('butlerJob.path.imgAlt')}
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
          </div>

          <div>
            {renderParagraphs(
              t('butlerJob.path.para1'),
              'text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.9] mb-6',
            )}
            {renderParagraphs(
              t('butlerJob.path.para2'),
              'text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.9] mb-6',
            )}
            {renderParagraphs(
              t('butlerJob.path.para3'),
              'text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.9] mb-8',
            )}

            <div className="flex flex-col sm:flex-row flex-wrap gap-x-8 gap-y-3">
              {links.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="inline-flex items-center gap-2 text-[15px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors"
                >
                  {t(link.key)}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
